<template>
  <a-card size="small" title="环境/架构分布图">
    <div class="arch-chart">
      <e-chart
        style="width: 100%; height: 100%;"
        :options="options"
        autoresize
        dom-id="opensource-arch-chart" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'ArchChart',
  props: {
    data: Object,
  },
  computed: {
    options () {
      const { running_envs = {}, cpu_archs = {} } = this.data
      const seriesData1 = []
      const seriesData2 = []
      Object.keys(running_envs).forEach(key => {
        seriesData1.push({ name: key, value: running_envs[key] })
      })
      Object.keys(cpu_archs).forEach(key => {
        seriesData2.push({ name: key, value: cpu_archs[key] })
      })
      seriesData1.sort((a, b) => a.value - b.value)
      seriesData2.sort((a, b) => a.value - b.value)
      return {
        series: [
          {
            type: 'pie',
            radius: '40%',
            center: ['50%', '50%'],
            label: {
              formatter: '{b}：{c}',
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
            },
            left: '10%',
            right: '60%',
            top: 0,
            bottom: 0,
            data: seriesData1,
          },
          {
            type: 'pie',
            radius: '40%',
            center: ['50%', '50%'],
            label: {
              formatter: '{b}：{c}',
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
            },
            right: '10%',
            left: '60%',
            top: 0,
            bottom: 0,
            data: seriesData2,
          },
        ],
      }
    },
  },
}
</script>

<style lang="less" scoped>
.arch-chart {
  height: 350px;
  ::v-deep {
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
